import client from "@/api";

export const getContracts = async () => {
  return await client.get("/opportunities");
};
